import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpHandlerService } from 'src/app/shared-resources/services/http-handler.service';
import { UrlMapService } from 'src/app/shared-resources/services/url-map.service';
import { AccessResponse, MLSCompanies, BiographyDetail, SelectLogo, MLSID, AgentInfo } from '../models/personal-info.model';
@Injectable({
  providedIn: 'root'
})

export class PersonalInfoService {

  /** return selected menu  */
  get selectedMenu(): string {
    return sessionStorage.getItem('perosnalInfoSelectedMenu') as string;
  }

  constructor(
    private urlMapService: UrlMapService,
    private https: HttpHandlerService,
    private httpClient: HttpClient
  ) {
    // blank constructor
  }

  /** update selected personal info menu */
  public updateSelectedMenu(menuName: string): void {
    sessionStorage.setItem('perosnalInfoSelectedMenu', menuName);
  }

  /** get logo from db */
  public getLogos(agentNumber: number): Observable<SelectLogo> {
    let url = this.urlMapService.getLogosUrl() + agentNumber + '/logos';
    return this.httpClient.get<SelectLogo>(url);
  }

  /** get portal site details api method */
  getPortalsiteDetails(id: any): any {
    const url = this.urlMapService.portalsiteDetailUrl() + id;
    const opts = { observe: 'response' };
    return this.https.get(url, opts);
  }

  /** upload Images */
  uploadPhotos(reqObj: any, id: any) {
    const url = this.urlMapService.uploadPhotosUrl() + 'agentPortalSiteId=' + id;
    return this.https.post(url, reqObj);
  }

  /** get photos api method */
  getPhotosUrl(id: any) {
    const url = this.urlMapService.getPhotosUrl() + id + '/photos';
    const opts = { observe: 'response' };
    return this.https.get(url, opts);
  }

  /** change selection */
  changeSelection(id: any, photoId: any) {
    const url = this.urlMapService.changeSelectedUrl() + 'agentPortalSiteId='
      + id + '&photoId=' + photoId;
    return this.https.post(url);
  }

  /** delete picture method here */
  deletePicture(reqArr: any[], id: any) {
    const opts = { body: reqArr };
    const url = this.urlMapService.deleteImageUrl() + id + '/delete-photos';
    return this.https.delete(url, opts);
  }

  /** get primary details api method */
  getPrimaryOfficeDetails(agentNumber: number) {
    const url = this.urlMapService.getPrimaryOfficeUrl() + agentNumber + '/primary-office-detail';
    const opts = { observe: 'response' };
    return this.https.get(url, opts);
  }
  getPreferredOfficeDetails(agentNumber: number) {
    const url = this.urlMapService.getPrimaryOfficeUrl() + agentNumber + '/preferred-office-detail';
    const opts = { observe: 'response' };
    return this.https.get(url, opts);
  }

  /** get Designation for agent api method */
  getDesignations(agentNumber: number) {
    const url = this.urlMapService.getDesignations() + agentNumber + '/designations';
    const opts = { observe: 'response' };
    return this.https.get(url, opts);
  }

  /** save Designation for agent api method */
  saveDesignations(obj: any) {
    const url = this.urlMapService.saveDesignations();
    return this.https.post(url, obj);
  }

  /** save default logo */
  saveDefaultLogo(agentNumber: any, id: number): Observable<AccessResponse> {
    const url = this.urlMapService.saveDefaultLogoUrl() + 'agentNumber=' + agentNumber.toString() + '&logoId=' + id;
    return this.httpClient.post<AccessResponse>(url, null);
  }

  /** get biography details api method */
  getBiographyDetails(portalSiteId: string): Observable<BiographyDetail> {
    const url = this.urlMapService.getBiographyUrl() + portalSiteId + '/biography';
    return this.httpClient.get<BiographyDetail>(url);
  }

  /** get contact info api method */
  getContactInfo(agentNumber: string): Observable<any> {
    const url = this.urlMapService.getContactInfoUrl() + agentNumber + '/contact-info';
    return this.httpClient.get<any>(url);
  }

  /** save default logo */
  shareQRCode(req: any): Observable<AccessResponse> {
    const url = this.urlMapService.shareQRCodeUrl();
    return this.httpClient.post<AccessResponse>(url, req);
  }

  /** save biography details */
  saveBiographyDetails(data: any): Observable<AccessResponse> {
    const url = this.urlMapService.saveBiographyUrl();
    return this.httpClient.post<AccessResponse>(url, data);
  }

  /** get contact info api method */
  saveContactInfo(data: any): Observable<any> {
    const url = this.urlMapService.getContactInfoUrl() + 'contact-info';
    return this.httpClient.post<any>(url, data);
  }
  updateContactInfo(data: any): Observable<any> {
    const url = this.urlMapService.getContactInfoUrl() + 'contact-info';
    return this.httpClient.put<any>(url, data);
  }
  deleteContactInfo(data: any): Observable<any> {
    const url = this.urlMapService.getContactInfoUrl() + 'contact-info/delete';
    return this.httpClient.post<any>(url, data);
  }

  /** get mls companies */
  getMLSCompanies(): Observable<MLSCompanies[]> {
    const url = this.urlMapService.getMLSCompanies();
    return this.httpClient.get<MLSCompanies[]>(url);
  }

  /** get mls IDs */
  getMLSIDs(agentNumber: string): Observable<MLSID[]> {
    const url = this.urlMapService.getMLSIDs() + agentNumber + '/mls-companies';
    return this.httpClient.get<MLSID[]>(url);
  }

  /** save mls IDs */
  saveMLSIDs(agentNumber: string, data: any): Observable<AccessResponse> {
    const url = this.urlMapService.saveMLSIDs() + 'mls-companies?agentNumber=' + agentNumber;
    return this.httpClient.post<AccessResponse>(url, data);
  }

  /** validate mls IDs */
  validateMLSIDs(mlsCompanyId: any, agentMlsNumber: any): Observable<boolean> {
    const url = this.urlMapService.validateMLSIDs() + 'mls-companies/' + mlsCompanyId + '/check-exists/' + agentMlsNumber;
    return this.httpClient.get<boolean>(url);
  }
  /** get Specialties for agent api method */
  getSpecialities(agentNumber: number) {
    const url = this.urlMapService.getSpecialitiesUrl() + agentNumber + '/specialities';
    const opts = { observe: 'response' };
    return this.https.get(url, opts);
  }

  


  /** get state list api method */
  getStateList() {
    const url = this.urlMapService.getStatesUrl();
    const opts = { observe: 'response' };
    return this.https.get(url, opts);
  }

  getAgentLicensedStateList(value: string)
  {
    const url = this.urlMapService.getAgentLicensedStateUrl() + value;
    const opts = { observe: 'response' };
    return this.https.get(url, opts);
  }

  /** get county list api method */
  getCountyList(state: string) {
    const url = this.urlMapService.getCountyUrl() + 'StateId=' + state;
    const opts = { observe: 'response' };
    return this.https.get(url, opts);
  }

  /** get city list api method */
  getCitiesList(state: string) {
    const url = this.urlMapService.getCitiesUrl() +'/'+state;
    const opts = { observe: 'response' };
    return this.https.get(url, opts);
  }

  /** save county api method */
  saveCounty(obj: any) {
    const url = this.urlMapService.saveCountyUrl();
    return this.https.post(url, obj);
  }

  /** save cities api method */
  saveCiti(obj: any) {
    const url = this.urlMapService.saveCityUrl();
    return this.https.post(url, obj);
  }

  /** get cities list  */
  getCityListUrl(portalSiteId: string) {
    const url = this.urlMapService.getCityListUrl() + portalSiteId + '/cities';
    return this.https.get(url);
  }

  /** get cities list  */
  getCountyListUrl(portalSiteId: string) {
    const url = this.urlMapService.getCountyListUrl() + portalSiteId + '/counties';
    return this.https.get(url);
  }

  /** save Specialities for agent api method */
  saveSpecialities(obj: any) {
    const url = this.urlMapService.saveSpecialitiesUrl();
    return this.https.post(url, obj);
  }  

  /** get Languages for agent api method */
  getLanguages(agentNumber: number) {
    const url = this.urlMapService.getLanguagesUrl() + agentNumber + '/languages';
    const opts = { observe: 'response' };
    return this.https.get(url, opts);
  }

  /** get zillow options for agent api */
  getZillowOptions(agentNumber: number){
    const url = this.urlMapService.getZillowOptionUrl() + agentNumber + '/display-options/ZILLOW/';
    const opts = { observe: 'response' };
    return this.https.get(url, opts);
  }

  /** get Testimonial options for agent api */
  getTestimonialOptions(agentNumber: number){
    const url = this.urlMapService.getTestimonialOptionUrl() + agentNumber + '/display-options/TESTIMONIALTREE/';
    const opts = { observe: 'response' };
    return this.https.get(url, opts);
  }

   /** save Zillow options for agent api */
   saveZillowOptions(agentNumber: number, isDisplay:boolean, obj: any){
    const url = this.urlMapService.saveZillowOptionUrl() + agentNumber + '/display-options?displayOptionType=ZILLOW&isDisplay=' + isDisplay;
    return this.https.post(url, obj);
  }

    /** save Zillow options for agent api */
    saveTestimonialOptions(agentNumber: number, isDisplay:boolean, obj: any){
      const url = this.urlMapService.saveTestimonialOptionUrl() + agentNumber + '/display-options?displayOptionType=TESTIMONIALTREE&isDisplay=' + isDisplay;
    return this.https.post(url, obj);
  }

  /** save Languages for agent api method */
  saveLanguages(obj: any){
    const url = this.urlMapService.saveLanguagesUrl();
    return this.https.post(url, obj);
  } 
  
  
  /** get core service details api */
  getCoreServices(agentNumber: number){
    const url = this.urlMapService.getPrimeryCoreService() + agentNumber + '/core-services';
    const opts = { observe: 'response' };
    return this.https.get(url, opts);
  }

  /** get core service type api */
  getCoreServiceTypeList() {
    const url = this.urlMapService.getCoreServiceType();
    const opts = { observe: 'response' };
    return this.https.get(url, opts);
  }

  /** get core servie Employee name list */
  getCoreEmployeeName(serviceId: string) {
      const url = this.urlMapService.getCoreEmployeeName() + 'CoreServiceId=' + serviceId;
      const opts = { observe: 'response' };
      return this.https.get(url, opts);
    }

    /** get Team Role info */
    getDelegate(agentNumber: number) {
      const url = this.urlMapService.getDelegates() + agentNumber;
      const opts = { observe: 'response' };
      return this.https.get(url, opts);
    }
  /** get social network affilations */
  getSocialNetworkLinks(agentNumber: number) {
    const url = this.urlMapService.getSocialNetworkLinksUrl() + agentNumber + '/social-networks';
    const opts = { observe: 'response' };
    return this.https.get(url, opts);
  }

  /** save social network affilations */
  saveSocialNetworkLinks(obj:any) {
    const url = this.urlMapService.saveSocialNetworkLinksUrl();
    return this.https.post(url, obj);
  } 

    /** save delegates */
    saveDelegate(obj:any) {
      const url = this.urlMapService.saveDelegates();
      return this.https.post(url, obj);
    } 

  /** regenerate password */
  regeneratePassword(data: any): Observable<AccessResponse> {
    const url = this.urlMapService.regeneratePassword();
    return this.httpClient.post<AccessResponse>(url, data);
  }

  /** agent info */
  getAgentInfo(agentNumber: any): Observable<AgentInfo>{
    const url = this.urlMapService.getAgentInfo() + agentNumber + '/agent-info';
    return this.httpClient.get<AgentInfo>(url);
  }

  /** get office core services */
  getOfficeCoreServices(agentNumber: any) {
    const url = this.urlMapService.getAgentInfo() + agentNumber + '/office-core-services';
    return this.httpClient.get<AgentInfo>(url);
  }

  /** post office core services */
  postOfficeCoreServices(agentNumber: any, obj: any) {
    const url = this.urlMapService.getAgentInfo() + agentNumber + '/office-core-services';
    return this.httpClient.post<AgentInfo>(url, obj);
  }  
}
